import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// components
import HeaderView from '../../components/Header';

const HeaderPropTypes = {
  title: PropTypes.string.isRequired, // Title for the application
  body: PropTypes.string.isRequired, // Description of the application
  editing: PropTypes.bool.isRequired, // If the route is being edited
  prevState: PropTypes.shape({}).isRequired, // The state of the application before a user edits their route
  directionsError: PropTypes.bool.isRequired, // True if an error occurred
  toggle: PropTypes.bool.isRequired, // State of the Vehicle selector
  isMobile: PropTypes.bool.isRequired, // True when the app is loaded on a handheld sized device
};

const HeaderDefaultProps = {};

const Header = props => <HeaderView {...props} />;

Header.propTypes = HeaderPropTypes;

Header.defaultProps = HeaderDefaultProps;

const mapStateToProps = state => ({
  title: state.Header.title,
  body: state.Header.body,
  editing: state.Places.editing,
  prevState: state.App.prevState,
  directionsError: state.Directions.directionsError,
  toggle: state.Vehicle.toggle,
  isMobile: state.App.isMobile,
});

export default connect(
  mapStateToProps,
  null,
)(Header);
